import { SecurityRepository } from '../repositories/security.repository'
import {
    DoDriverSearchParamsT,
    DoDriverSearchResponse,
    SecurityGetAutoInformationResponseT,
    SecurityGetCheckupStatusParams,
    SecurityGetCheckupStatusResponseT,
    SecurityGetCompanyInformationResponseT,
    SecurityGetPersonInformationResponseT,
    SecurityGetSbHistoryResponse,
    SecurityHistoryItemT,
    SecurityHistoryParamsT,
} from '../types/security.types'

const securityRepository = new SecurityRepository()

export class SecurityService {
    async getPersonInformation(person_iin: string): Promise<SecurityGetPersonInformationResponseT> {
        const response = await securityRepository.getPersonInformation(person_iin)
        return response.data
    }

    async createPersonInformationRequest(person_iin: string): Promise<void> {
        const response = await securityRepository.createPersonInformationRequest(person_iin)
        return response.data
    }

    async getCompanyInformation(
        company_bin: string
    ): Promise<SecurityGetCompanyInformationResponseT> {
        const response = await securityRepository.getCompanyInformation(company_bin)
        return response.data
    }

    async createCompanyInformationRequest(company_bin: string): Promise<void> {
        const response = await securityRepository.createCompanyInformationRequest(company_bin)
        return response.data
    }

    async getAutoInformation(number: string): Promise<SecurityGetAutoInformationResponseT> {
        const response = await securityRepository.getAutoInformation(number)
        return response.data
    }

    async createAutoInformationRequest(number: string, technical_passport: string): Promise<void> {
        const response = await securityRepository.createAutoInformationRequest(
            number,
            technical_passport
        )
        return response.data
    }

    async setCheckupAccept(
        identifier: string,
        type: number,
        comment: string | null
    ): Promise<void> {
        const response = await securityRepository.setCheckupAccept(identifier, type, comment)
        return response.data
    }

    async setCheckupReject(identifier: string, type: number, comment: string): Promise<void> {
        const response = await securityRepository.setCheckupReject(identifier, type, comment)
        return response.data
    }

    async getCheckupStatus(
        params: SecurityGetCheckupStatusParams
    ): Promise<SecurityGetCheckupStatusResponseT> {
        const response = await securityRepository.getCheckupStatus(params)
        return response.data
    }

    async getSbHistory(params: SecurityHistoryParamsT): Promise<SecurityGetSbHistoryResponse> {
        const response = await securityRepository.getSbHistory(params)
        return response.data
    }

    async doDriverSearch(params: DoDriverSearchParamsT): Promise<DoDriverSearchResponse> {
        const response = await securityRepository.doDriverSearch(params)
        return response.data
    }
}
